import { Component } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-radio',
  templateUrl: './app-radio.component.html',
})
export class AppRadioComponent extends FieldComponent {
  enableMap: { [key: string]: boolean } = {};

  override ngOnInit() {
    super.ngOnInit?.();
    const enableConfig = this.field?.customAttributes?.enable ?? {};

    this.enableMap = {};
    this.options.forEach(option => {
      this.enableMap[option.fieldOptionId] = enableConfig[option?.fieldOptionId] ?? true;
    });
  }

  isEnabled(optionId) {
    const enabled = this.enableMap?.[optionId] ?? true;
    return enabled;
  }
}
